import { render, staticRenderFns } from "./radicarInclusion.vue?vue&type=template&id=4a2c0a5e&"
import script from "./radicarInclusion.vue?vue&type=script&lang=js&"
export * from "./radicarInclusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports